import { EMAIL_EMPTY, EMAIL_INVALID } from "constants/errorMessages";
import Joi from "joi";

export const forgotPasswordFormSchema = Joi.object({
    email: Joi.string().email({ tlds: false }).required().messages({
        "string.empty": EMAIL_EMPTY,
        "string.email": EMAIL_INVALID
    })
});
